const apiMap = {
  localhost: 'https://h5.yunkeduntest.com',
  'management.schoolweb.yunkeduntest.com': 'https://h5.yunkeduntest.com',
  'management.schoolweb.yunkedun.com': 'https://h5.yunkedun.com',
};

const h5Url = apiMap[window.location.hostname]; // 总校区api地址，分校区api根据校区接口返回的domain

export default h5Url;



// WEBPACK FOOTER //
// ./src/utils/h5Url.js